var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-found"},[_c('div',{staticClass:"no-data-found__image"},[_c('FeatherIcon',{attrs:{"icon":"FrownIcon","size":"70"}})],1),_c('h3',[_vm._v(_vm._s(_vm.$t('g.no_data')))])])}
var staticRenderFns = []

export { render, staticRenderFns }